import Super from 'client-portal/routes/-request/clinician';
import classic from 'ember-classic-decorator';

@classic
export default class SiteRequestClinician extends Super {}
